import type { IconProps } from './types';

export const IndicatorIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 10, ref, ...other } = props;

  return (
    <svg width={4} height={size} viewBox="0 0 4 10" fill="none" ref={ref} {...other}>
      <path d="M0 0H4L2 10L0 0Z" fill={color} />
    </svg>
  );
};
